import { cn } from "@/lib/utils";
import { useEffect, useState } from "react";

export const AppLogo = ({ className }: { className?: string }) => {
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    if (counter > 8) {
      setCounter(0);
      throw new Error("TEST ERROR");
    }
  }, [counter]);

  return (
    <div className={cn("p-6", className)} onClick={() => setCounter(counter + 1)}>
      <img src="/HeyBodhiLogo-White.png" alt="hey bodhi logo" className="h-12 w-auto mx-auto" />
    </div>
  );
};
